import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth48: ToothDataEntry = {
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M44,353.4c96.7-18.5,129,.4,129,.4l14.3,46.4,3.5,14.4,1.5,12.3.2,10-3.9,14.8-4.7,8-7.5,6.3-10.7,4-20.3.2-14.7-1.5-16.1-5.7-30.7,3.1-14.7,2-15-4.8-9.1-9-7-11.8-3.5-12.1-1.7-8.8v-12.2s.4-13.7.4-13.7l2.9-18.1,5.5-18.6,2.6-5.6h-.3Z',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M127.1,377.9a16.6,16.6 0 1,1 -33.2,0a16.6,16.6 0 1,1 33.2,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M176.1,367.7s-15.3-.8-25.6.7c-10.4,1.5-7.8,13.6-7.8,13.6l4.2,87.5s3.2.9,12.3.3c37.9-2.6,32-37.4,32.9-43.1,1-6-16-58.9-16-58.9h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M38.7,369.8s19.4.8,29.5.8c10.1,0,9.5,11.2,9.5,11.2l4,84.4-12.1.6s-12.9-.3-17.2-5.2c-32.7-23.9-13.7-91.8-13.7-91.8h0Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M41,359.2l2.3-5.8s34.5-6.9,60.5-7.7c0,0-14.1,69.4-.9,78.1,18.1,11.9,9.9,39.1,9.9,39.1l-44.1,3.9s-11.5-.7-16.9-5.6c-40.4-37.2-10.8-102-10.8-102h0Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M173.3,353.8s-17.1-10.1-69.4-8.1c0,0-14,70.2-.9,78.1,18.1,12,9.9,39.1,9.9,39.1,0,0,24.4,9.2,46.3,7,37.8-3.6,32-37.4,32.9-43.1,1-6.1-17.8-70.2-17.8-70.2,0,0-1-2.8-1-2.8Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M173.3,353.8l-1.6-7.7-1.2-6.6c-54.5-10.8-122.7,2.4-122.7,2.4l-3.5,11.5c95.1-18.3,129,.4,129,.4h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'34.7 424 48.7 398.8 58.8 432 66.6 390.4 83.1 431.4 93 388.6 109.8 429.2 120.1 386.8 137.4 429.9 146.1 387.2 164.1 428.2 166.4 392.7 187.4 412.9',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'70.8 351 81.3 343 67.3 337 77.9 328.9 65 323.2 75 315.5 63.4 310.5 73.2 303.1 59.8 297.3 69.4 290.1 58.7 285.5 68.3 278.2 56.6 273.2 66.8 265.5 55.8 260.9 66 253.2 55.7 248.6 65.6 241.2 53.1 235.8 64.7 227 52.8 221.7 64.2 213.1 51.8 207.8 63.1 199.3 49 193.1 59.3 185.3 46.2 179.6 58.6 170.3 46.1 164.9 57.3 156.5 44.1 150.8 55.8 141.9 42.9 136.3 54.5 124.8 40.4 122.2 50.8 107.4',
				'111.3 109.5 124.7 118.5 120.9 129.5 135.8 130.6 130.4 142.8 142.3 146.6 130.9 157.5 143 164.4 131.4 171.4 144.9 178.9 132.6 186.3 143.9 192.8 130.8 200.7 143.1 207.6 131.4 214.6 143.9 221.6 132.8 228.4 145.4 235.6 133.8 242.5 144.6 248.6 135 254.5 146 260.8 135.8 266.8 146.8 273.2 135.9 279.6 146.4 285.6 136.3 291.5 146.8 297.4 134.3 304.9 145 311 134.1 317.5 145.1 323.8 133 331.1 144.6 337.7 131.5 345.5 143 352.1',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'172.5 239.9 156.7 224.9 143.7 242.1 125.7 225.4 109.6 244.4 94.1 226.8 79.3 243.3 65.2 230.9 55.1 246 43.6 230.8 35.5 246.5',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '140.7 185.7 119 193.6 101.4 195.7 74.6 195.5 64.7 193.5 50.2 188.7 35.5 182.3 23.6 169.5 12.8 136.7 10.3 125.9 12.9 75.5 18.8 60.6 33.1 46.9 65.1 36.4 88.4 36.9 120.9 44.7 137.9 44.3 153.3 47.3 169.4 53.9 180 64.4 185.6 79.8 187.5 91.9 187.9 125.9 185.6 143 175.4 158.5 140.7 185.7',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M146.5,87.8l35.5-18.8,3.6,9.1,1,9.9,1.3,11.7-.3,28.9-1.8,14.6-5.5,6.8-37.1-24.9s-9.4-6.8-13.6-9.8c-14.7-10.7,0-18.5,0-18.5l16.9-9h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M17.1,67.5l-1.9,3.2-2.1,7-1.8,11.3-.3,36.4s3.9,33.9,12.9,40.5l24.2-36.4,8.3-12.5c9.8-11.1-2.2-17.9-2.2-17.9l-9.7-8.2-27.3-23.5h0Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M48.2,129.6l-24.2,36.4.5,5.4,10.9,11.2,5,1.2,5.2,3.1,8.3,3.8,7.9,2.3,14.3,2.6s10.3-38.5,6.7-54.2c-3.6-15.7-7-19-8.6-19.8-4.1-2.1-26.2,7.9-26.2,7.9h.2Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M180.4,150l-5,8.5-7.5,6.5-27.2,20.7-20.9,7.3-18.4,2.6h-25.4c3.8-14.9,9.4-37.4,6.7-54.2-3.7-18.5-14.8-21.3-8.4-19.9,6.4,1.4,12.1,26.2,29,11.9,17-14.2,40-8.3,40-8.3l37.1,24.9h0Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M182.1,69h0l-35.5,18.8c-30.4,15.1-33.4-4.9-53.6-3.8,0,0,7.2-12.2,4.6-20.6.6-7.7,5.3-22.2,5.3-22.2l17.2,3.3,17.9-.2,16,3.4,15.1,6.3,8.3,8.4,4.4,6.6h.3Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M102.7,41.1h0c-4.6,16.3-5.2,22.3-5.2,22.3,1.7,5.2.5,11.2-4.6,20.6,0,0-12.9.8-18.7,5.8-5.8,4.9-9.8,4.9-13.8,4.4s-15.9-3.4-15.9-3.4l-27.3-23.5,1.6-6.8,5.1-5,4.5-3.5,4.7-5.2,7.6-2.2,8.3-3.1,9.2-2.3,6.9-2.7,23.3.4,14.3,4.3h0Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M139.1,91l7.5-3.2s-2.2,1.1-11.9,6.4-17.5,11.4-5.1,20.9c3.4,2.4,13.7,10,13.7,10,0,0-19.4-5.5-40,8.3-1.5,1.5-9,8.9-17.6,1.1-3.2-3-9.7-13.3-11.4-13-6.3-1.3-26.2,7.9-26.2,7.9l8.3-12.5c11.9-14.3-11.7-22.4-11.9-26.1l15.9,3.4c5.6.9,9.1-.6,13.8-4.4,5-4,13.4-5.2,18.7-5.8,16-1.8,23.7,15.3,46.1,7h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'10.9 107 29.6 133.8 37.5 95.5 50.7 141.7 64.9 93.4 80.7 140.8 95.4 93.1 111.7 139.8 126.2 89.2 140.9 136.4 156.6 88.3 163.2 128 184.7 102.9',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M172.2,167.7s-61,36-141.1,8.9l-3.3-6.8-2.7-5.9-5.1-12.7-4.4-15.7-2.8-14-1.7-10.3-1.1-13.1-.2-14,.4-5.5.8-6.6,3.6-6.8,6.3-3.2,15.6.5,8.1-4.3,3.3-.9,3.9-2.9,20.1-10.8,41.8-2.9,18.4-4.6,16.9,3.3,18.3,7.3,3.3-.8,4.6-.7,4.3.2,2.9,1.3,1.6,2.4,3.2,5.8,1.8,6.3s1.7,9,1.8,9v9s-1.5,14.2-1.5,14.2l-15.3,56.5-1.9,17.8h0Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M114.8,138.5a17,17 0 1,1 -34,0a17,17 0 1,1 34,0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M58.8,50.9h0s3.2,78.9.7,104.6c0,6.3-4.5,10.5-10.7,10.5l-22.4,1.3-6.3-16.3-2.7-8.5-4-17.7-1.9-18.9-1.7-18,1-13.4,3.1-7.6,8.1-5.1,11.1.7h7.3s18.5-11.6,18.5-11.6h-.1Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M171.8,167.8s-24.3,14.6-62.5,18c-17.4-23.8,12.3-112.8,3.5-144.2l19-4.9,7.3,1.1,9.3,2.8,8.4,2.5,10.5,3.8,6.3-1.2,5.6.5h0l3.2,1,3.4,3.6,2,5.8,1.6,6.1.9,8.3v14.7s-16.5,57.7-16.5,57.7l-1.7,13.5v10.8s-.3.1-.3.1Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M109.4,185.8s-36.9,5.2-78.6-9.1l-4.5-9.4-6.3-16.3-2.7-8.5-4-17.7-1.9-18.9-1.7-18,1-13.4,3.1-7.6,8.1-5.1,11.1.7h7.3s29.8-18.4,29.8-18.4h0l16.4-1.3,26.5-1.4c9.6,31.2-20.6,114.7-3.4,144.3h-.2Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M172,167.6l-.2,14.8c-82.4,36.6-136.7,7.4-136.7,7.4l-4.1-13.2c80.7,26.7,141.1-8.9,141.1-8.9h0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M172.2,160l15.6-60.1,2.5-14.3v-14.7s-.8-8.3-.8-8.3l-1.6-6.1-2-5.8-3.4-3.6-3.1-1-5.6-.5-6.3,1.2-15.6-7-19.3-3.3s1.3,106.2,1.4,113.5,4.9,11.3,11.1,11.2,27.2-1.1,27.2-1.1h-.1Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'12.8 101.2 30.9 129.2 39.9 90 51.7 137.6 67.2 88.7 81.6 137.6 97.8 89.3 112.7 137.6 128.9 86.2 141.9 135.1 159.3 86.2 164.7 127.2 186.7 102.2',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'66 414.3 53.5 403.4 66.3 396.8 53.7 388.5 66.7 381.9 54.9 374.1 67.1 367.8 54 359.2 66.9 352.6 55.9 345.3 69.8 338.1 57.7 330.2 70 323.9 57.8 316 69.6 309.8 57.2 301.6 69.5 295.4 58.9 288.5 69.1 283.2 58.3 276 69.1 270.6 58.3 263.4 69.8 257.5 59.6 250.8 70.2 245.4 59.9 238.7 73.1 232 62.7 225.1 74.1 219.2 63.4 212.1 76.2 205.5 64.9 198 78.7 190.9 67.5 183.5',
				'140.7 177.6 129.5 185 143.3 192 132 199.5 144.8 206.1 134 213.3 145.5 219.1 135.1 226.1 148.3 232.8 138 239.5 148.6 244.9 138.3 251.6 149.9 257.5 139.1 264.6 149.9 270.1 139.1 277.2 149.2 282.5 138.7 289.4 151 295.7 138.6 303.8 150.4 310 138.2 318 150.5 324.3 138.4 332.2 152.3 339.3 141.3 346.6 154.2 353.3 141 361.9 153.3 368.2 136.9 374.7 146.6 384.4 132.2 388.1 135.5 398.7 123 398.7 120.3 410.3',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'33.5 295.9 43.1 311.2 53.8 295.1 65.2 309.7 78.9 296.2 95.1 312 109.9 293.1 127.7 311.2 145.1 293.1 159.7 309.7 174.9 293.4',
			],
		},
	},
};
